import { useEffect, useState } from "react";
import api from "../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { toast } from "sonner";
import { Star } from "@phosphor-icons/react";

export default function AdminPanel() {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [events, setEvents] = useState([]);
  const [orders, setOrders] = useState([]);

  const load = () => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
    api.get("/admin/users").then(({ data }) => setUsers(data));
    api.get("/organizer/events").then(({ data }) => setEvents(data));
    api.get("/admin/orders").then(({ data }) => setOrders(data));
  };
  useEffect(() => { load(); }, []);

  const toggleFeature = async (id) => {
    await api.put(`/admin/events/${id}/feature`);
    toast.success("Updated");
    load();
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 dark:bg-[#0B0F1A]" data-testid="admin-panel">
      <span className="label-eyebrow">Admin</span>
      <h1 className="font-display text-4xl sm:text-6xl mt-2 tracking-tighter dark:text-white">Control room.</h1>

      {stats && (
        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { l: "Users", v: stats.users },
            { l: "Events", v: stats.events },
            { l: "Orders", v: stats.orders },
            { l: "Revenue", v: `৳${stats.revenue.toLocaleString()}` },
          ].map((s) => (
            <div key={s.l} className="stat-card dark:bg-[#111827]">
              <p className="font-display text-3xl dark:text-white" data-testid={`admin-stat-${s.l}`}>{s.v}</p>
              <p className="text-xs uppercase tracking-widest text-neutral-500 dark:text-neutral-400 mt-1">{s.l}</p>
            </div>
          ))}
        </div>
      )}

      <Tabs defaultValue="events" className="mt-12">
        <TabsList className="bg-transparent border-b border-neutral-200 dark:border-neutral-700 rounded-none">
          <TabsTrigger value="events" className="rounded-none data-[state=active]:bg-black data-[state=active]:text-white" data-testid="admin-tab-events">Events</TabsTrigger>
          <TabsTrigger value="users" className="rounded-none data-[state=active]:bg-black data-[state=active]:text-white" data-testid="admin-tab-users">Users</TabsTrigger>
          <TabsTrigger value="orders" className="rounded-none data-[state=active]:bg-black data-[state=active]:text-white" data-testid="admin-tab-orders">Orders</TabsTrigger>
        </TabsList>

        <TabsContent value="events" className="mt-6">
          <div className="table-container">
            <table className="w-full text-sm">
              <thead><tr><th>Title</th><th>Organizer</th><th>Date</th><th>Status</th><th>Featured</th></tr></thead>
              <tbody>
                {events.map(e => (
                  <tr key={e.id}>
                    <td className="p-3 font-bold dark:text-white">{e.title}</td>
                    <td className="p-3 dark:text-neutral-300">{e.organizer_name}</td>
                    <td className="p-3 dark:text-neutral-300">{new Date(e.date).toLocaleDateString()}</td>
                    <td className="p-3"><span className="text-xs uppercase font-bold dark:text-neutral-300">{e.status}</span></td>
                    <td className="p-3">
                      <button onClick={() => toggleFeature(e.id)} className="hover:text-[#4F46E5] transition-colors" data-testid={`feature-${e.id}`}>
                        <Star size={20} weight={e.featured ? "fill" : "regular"} className={e.featured ? "text-[#4F46E5]" : "dark:text-neutral-500"} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>

        <TabsContent value="users" className="mt-6">
          <div className="table-container">
            <table className="w-full text-sm">
              <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Joined</th></tr></thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td className="p-3 font-bold dark:text-white">{u.name}</td>
                    <td className="p-3 dark:text-neutral-300">{u.email}</td>
                    <td className="p-3"><span className="text-xs uppercase font-bold dark:text-neutral-300">{u.role}</span></td>
                    <td className="p-3 text-xs text-neutral-500 dark:text-neutral-400">{u.created_at?.slice(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>

        <TabsContent value="orders" className="mt-6">
          <div className="table-container">
            <table className="w-full text-sm">
              <thead><tr><th>Order</th><th>User</th><th>Event</th><th>Total</th><th>Status</th></tr></thead>
              <tbody>
                {orders.map(o => (
                  <tr key={o.id}>
                    <td className="p-3 font-mono text-xs dark:text-neutral-300">{o.id.slice(0, 8)}</td>
                    <td className="p-3 dark:text-neutral-300">{o.user_email}</td>
                    <td className="p-3 dark:text-neutral-300">{o.event_title}</td>
                    <td className="p-3 font-bold dark:text-white">৳{o.total.toLocaleString()}</td>
                    <td className="p-3"><span className="text-xs uppercase font-bold text-[#10B981]">{o.payment_status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}